<template>
  <Accordion title="Dados da Movimentação">
    <div class="grid grid-cols-4 gap-5">
      <Select :items="type" v-model="localValue.type" label="Tipo" required :error="localErrors.type" :disabled="localValue.id" />

      <InputZoom
        required
        clearable
        label="Local Destino"
        :error="localErrors.idDestinationWarehouse"
        v-model="localValue.idDestinationWarehouse"
        :filter="[{ column: 'type', value: 'physic' }]"
        database="warehouse"
        item-value="id"
        item-text="name" />
      <InputZoom
        clearable
        required
        v-model="localValue.idDestinationWarehouse"
        label="Local Destino"
        :error="localErrors.idDestinationWarehouse || localErrors.sameWarehouse"
        database="warehouse"
        item-text="name"
        item-value="id" />

      <InputDateTime v-model="localValue.date" label="Data" required :error="localErrors.date" timeStamp />
    </div>
  </Accordion>
  <Accordion title="Relação de Itens">
    <div v-if="!this.$route.params.id" class="mt-3">
      <Flex justify-end class="mb-3">
        <InputZoomMultiple
          class="col-span-2"
          v-model="idItem"
          clearable
          label="Item"
          :error="localErrors.items || localErrors.duplicateItem"
          database="item"
          item-value="id"
          item-text="name"
          v-model:show="showItems">
          <template #container>
            <Button :class="`h-[44px] py-1 w-full ${localErrors.items ? 'mb-8' : ''}`" label="Adicionar Item(s)" icon="fa-solid fa-circle-plus" @click="showItems = true" primary />
          </template>
          <template #action>
            <Flex justify-end class="py-3">
              <Button label="Selecionar Materiais" icon="fa-solid fa-circle-plus" primary @click="addItem" />
            </Flex>
          </template>
        </InputZoomMultiple>
      </Flex>

      <TheTable cell-border dense :headers="headers" :items="listItems" :disablePagination="true" :error="errors.insufficientQuantity">
        <template v-slot:quantity="{ item }">
          <InputNumber dense v-model="item.quantity" />
        </template>
        <template v-slot:price="{ item }">
          <InputMoney dense v-model="item.price" />
        </template>
        <template v-slot:total="{ item }">
          <span v-if="item.quantity && item.price">
            {{ formatMoneyS(item.quantity * item.price) }}
          </span>
        </template>
        <template v-slot:actions="{ item }">
          <TheToolTip label="Excluir">
            <i class="fa-solid fa-trash cursor-pointer" @click="removeConfirm(item)"></i>
          </TheToolTip>
        </template>

        <template #footer v-if="listItems && listItems.length > 0">
          <td colspan="3"></td>
          <td class="px-2 py-1 font-semibold">Total:</td>
          <td class="px-2 py-1 font-semibold">
            {{ formatMoneyS(totalItems) }}
          </td>
        </template>
      </TheTable>
      <TheRequiredLabel class="py-3" />
      <Flex gap-2>
        <Button label="Salvar" icon="fa-solid fa-floppy-disk" primary @click="save" />
        <Button label="Cancelar" icon="fa-solid fa-x" danger @click="$router.back" />
      </Flex>
    </div>
  </Accordion>
</template>

<script setup>
import { reactive, ref, watch } from 'vue'

const type = [
  { label: 'Devolução ao Fornecedor', value: 'supplierDevolution' },
  { label: 'Fornecimento', value: 'outgoing' },
  { label: 'Devolução', value: 'devolution' },
  { label: 'Baixa', value: 'downward' },
  { label: 'Transferência', value: 'transfer' },
]

const orderType = [
  { label: 'ICL', value: 1 },
  { label: 'Pontual', value: 2 },
]

const props = defineProps({
  modelValue: Object,
  error: Object,
})

const emits = defineEmits(['update:modelValue'])

const localValue = reactive(props.modelValue)
const localErrors = ref(props.error)

watch(
  () => props.modelValue,
  (newValue) => {
    localValue.value = newValue
  },
)

watch(
  () => props.error,
  (newValue) => {
    localErrors.value = newValue
  },
)

watch(localValue, (newValue) => {
  emits('update:modelValue', newValue)
})
</script>
